export default __webpack_public_path__ + "static/lotte_hoppen-da0a85a074d26a585e90b8cb9e61c3e2.jpg";